import { forwardRef, SelectHTMLAttributes } from "react";
import { cn } from "@utils";

export type SelectOption = { value: string; label: string };

type SelectProps = {
  options: SelectOption[];
} & SelectHTMLAttributes<HTMLSelectElement>;

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  (props: SelectProps, ref) => {
    const { options, className, ...rest } = props;
    return (
      <select {...rest} ref={ref} className={cn(`c-select`, className)}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    );
  },
);

Select.displayName = "Select";
